import { type FC } from 'react'

interface Props {
  description: string
  number: number
  testId: string
  title: string
}

/**
 * Used for iterated Welcome steps
 * @param description - Description of the step
 * @param number - Number of the step
 * @param testId - Test ID for the component
 * @param title - Title of the step
 * @returns React.FC
 */
export const WelcomeStep: FC<Props> = ({ description, number, testId, title }) => {
  return (
    <div className="flex flex-row items-center mb-md" data-testid={testId}>
      {/* Number */}
      <div className="min-w-10 min-h-10 rounded-full border-2 border-action flex justify-center items-center mr-sm">
        <p className="typo-primary-lg-semibold" data-testid={`${testId}-number`}>
          {number}
        </p>
      </div>
      {/* Content */}
      <div>
        {/* Title */}
        <div className="typo-primary-lg-semibold text-text-header" data-testid={`${testId}-title`}>
          {title}
        </div>
        {/* Description */}
        <div className="typo-primary-sm text-text-meta" data-testid={`${testId}-description`}>
          {description}
        </div>
      </div>
    </div>
  )
}
